import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { Moon, Sun } from "lucide-react";
import { useThemeMode } from "../context/ThemeContext";

export function ThemeToggle({ className = "", variant = "icon" }: { className?: string; variant?: "icon" | "switch" }) {
  const { mode, toggleTheme } = useThemeMode();
  const nextLabel = mode === "dark" ? "切换到浅色模式" : "切换到深色模式";

  if (variant === "switch") {
    return (
      <Tooltip title={nextLabel}>
        <IconButton className={`theme-toggle theme-toggle-admin ${className}`.trim()} type="button" aria-label={nextLabel} onClick={toggleTheme}>
          {mode === "dark" ? <Sun aria-hidden="true" /> : <Moon aria-hidden="true" />}
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={nextLabel}>
      <IconButton className={`theme-toggle ${className}`.trim()} type="button" aria-label={nextLabel} onClick={toggleTheme}>
        {mode === "dark" ? <Sun aria-hidden="true" /> : <Moon aria-hidden="true" />}
      </IconButton>
    </Tooltip>
  );
}
